import { Button } from "@amzn/storm-ui";
import { isEmpty, isUndefined } from "lodash";
import * as React from "react";

import { TELEMETRY_ID } from "../../../../constants/telemetry";
import { usePitchFileUploadAction } from "../../../../hooks/pitchedContent/usePitchFileUploadAction";
import type { PitchFileUploadActionRequest } from "../../../../hooks/pitchedContent/usePitchFileUploadAction";
import { logWithTakt } from "../../../../utils/telemetry.utils";
import {
    ModalFooterCancelButton,
    ModalFooterContainer,
    DivFlexJustifyRight,
} from "../../../common/styled.components";

export interface UploadPitchedContentFooterProps {
    uploadProps: PitchFileUploadActionRequest;
    handleClose: () => void;
    onSubmit?: () => void;
}

export const UploadPitchedContentFooter: React.FunctionComponent<
    UploadPitchedContentFooterProps
> = (props: UploadPitchedContentFooterProps) => {
    const { uploadProps, handleClose, onSubmit } = props;
    const { insightTitle, file, contentId, accountOpportunityId } = uploadProps;

    const isUpload = isUndefined(contentId);

    const submitDisabled =
        isEmpty(insightTitle) ||
        (isUndefined(file) && isUndefined(contentId)) ||
        isEmpty(uploadProps.sfObject.sfObjectId);

    const [_, pitchFileUploadAsyncAction] =
        usePitchFileUploadAction(uploadProps);

    const handleTelemetry = () => {
        if (isUpload) {
            logWithTakt(TELEMETRY_ID.PITCHED_CONTENT_UPLOAD_CLICK, {
                opportunityId: accountOpportunityId,
                insightTitle,
            });
        } else {
            logWithTakt(TELEMETRY_ID.PITCHED_CONTENT_EDIT_CLICK, {
                opportunityId: accountOpportunityId,
                insightTitle,
                contentId,
            });
        }
    };

    const handleClick = async () => {
        handleClose();
        await pitchFileUploadAsyncAction.execute();

        handleTelemetry();

        onSubmit?.();
    };

    return (
        <ModalFooterContainer data-testid="upload-pitched-content-footer">
            <br />
            <DivFlexJustifyRight>
                <ModalFooterCancelButton
                    onClick={() => handleClose()}
                    data-testid="upload-pitched-content-cancel"
                >
                    Cancel
                </ModalFooterCancelButton>
                <Button
                    data-testid="upload-pitched-content"
                    type="submit"
                    variant="primary"
                    onClick={() => void handleClick()}
                    disabled={submitDisabled}
                >
                    {isUpload ? "Upload deck" : "Save"}
                </Button>
            </DivFlexJustifyRight>
        </ModalFooterContainer>
    );
};
